<script setup>
defineOptions({
  name: "UserTags",
});

defineProps({
  tags: { type: Array, required: true },
});
</script>

<template>
  <p class="tag-list mt-2 whitespace-normal">
    <span
      v-for="(tag, i) in tags"
      :key="i"
      class="tag is-on-picture"
    >
      <template v-if="tag.kind === 'online'">
        <online-badge class="is-online is-into-tag"></online-badge>
        <span class="font-bold">{{ tag.label }}</span>
      </template>
      <template v-else-if="tag.kind === 'distance'">
        <font-icon class="geolocation--fill"></font-icon>
        <span class="font-bold">{{ tag.label }}</span>
      </template>
      <template v-else>{{ tag.label }}</template>
    </span>
  </p>
</template>
